define [], () ->
  ($resource, RENTAPPLICATION_API_URL) ->
    (url) ->
      new $resource(
        url,
        {},
        {
          get:
            cache: true
        }
      )



// WEBPACK FOOTER //
// ./resources/ReportSourceProfile.coffee